export const wpUrl = process.env.GATSBY_WORDPRESS_URL || 'https://back.87seconds.com';
export const gatsbyUrl = process.env.GATSBY_URL || 'https://www.87seconds.com';

export const isAbsoluteUrl = (url) => {
  // Don't match Windows paths `c:\`
  if (/^[a-zA-Z]:\\/.test(url)) {
    return false;
  }

  // Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
  // Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3
  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
};

export const fixUrl = (url) => {
  if (!isAbsoluteUrl(url)) {
    return url;
  }

  if (url.startsWith(wpUrl)) {
    return url.replace(wpUrl, '');
  }

  return url;
};

export const replaceWpUrl = (url) => {
  return url.replace(wpUrl, gatsbyUrl);
};
